import { render, staticRenderFns } from "./gSwiper.vue?vue&type=template&id=14db1a4b"
import script from "./gSwiper.vue?vue&type=script&lang=js"
export * from "./gSwiper.vue?vue&type=script&lang=js"
import style0 from "./gSwiper.vue?vue&type=style&index=0&id=14db1a4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_esdk3aqwspx5xq2g2xm6lubema/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports